import supportsWebP from 'supports-webp';

export default function ChooseImageFormat() {
    supportsWebP.then(supported => {
        const $imageContainers = document.querySelectorAll('.article_lg');
        $imageContainers.forEach($image => {
            const webp = $image.getAttribute('data-webp');
            const jpg = $image.getAttribute('data-jpg');
            $image.style.backgroundImage = `url('${supported ? webp : jpg}')`;
        });
    });
}
